import React, { useCallback, useMemo } from 'react';
import Chips from 'atomic/form/chips';
import { useDispatch, useSelector } from '@ecommerce/nest-ssr/common';
import { OffersActions } from '../../../../../../../reducers/offers';
import { FILTER_OPTIONS, FILTER_GROUPS } from 'modules/product/views/components/product-offers-header/data/filter-options.data';
import Icon from 'atomic/icon';
import Button from 'atomic/button';
import { OptionDataInterface } from 'modules/product/views/components/product-offers-header/interfaces/option.data.interface';
import { ProductInterface } from 'modules/product/interfaces/product.interface';
import OfferInterface from 'interfaces/offer.interface';
import offersPrepare from 'helpers/offers-prepare';
import './product-offers-active-filters.scss';

const getFullActiveFilters = (array: string[]): OptionDataInterface[] => {
    if (!array) {
        return [];
    }

    return FILTER_OPTIONS.filter(item => array.includes(item.value));
};

interface ProductOffersActiveFiltersProps {
    selectedFilters: string[];
    onRemove?: (value: string) => void;
    onClear?: () => void;
}

const ProductOffersActiveFilters: React.FC<ProductOffersActiveFiltersProps> = ({
    selectedFilters,
    onRemove,
    onClear
}) => {
    const dispatch = useDispatch();
    const offers = useSelector<{ product: ProductInterface; }, OfferInterface[]>(state => [...offersPrepare(state.product.offers.items)]);
    const activeFilters = useMemo(() => {
        return getFullActiveFilters(selectedFilters);
    }, [selectedFilters]);

    const selectFilters = (activeFilters: string[]): void => {
        dispatch({ type: OffersActions.Filter, payload: { activeFilters, replaceState: true, items: offers } });
    };

    const onRemoveFilter = (value: string): void => {
        if (onRemove) {
            onRemove(value);
        }

        selectFilters(selectedFilters.filter((filter: string) => filter !== value));
    };

    const onClearFilters = useCallback(
        (): void => {
            if (onClear) {
                onClear();
            }

            selectFilters([]);
        }, [dispatch]
    );

    return (
        <>
            { activeFilters.length > 0 && (
                <>
                    <div className="product-active-filters">
                        <p className="product-active-filters__title">
                            Aktywne filtry
                        </p>
                        <div className="product-active-filters__list">
                            {FILTER_GROUPS.map(item => {
                                const filters = activeFilters.filter(filter => filter.group === item.value);

                                if (!filters.length) {
                                    return null;
                                }

                                return (
                                    <div className="product-active-filters__item" key={item.value}>
                                        <p className="product-active-filters__name">
                                            {item.label}
                                        </p>
                                        {filters.map(filter => (
                                            <div key={filter.value} className="item">
                                                <Chips onClick={(): void => onRemoveFilter(filter.value)}>
                                                    <span>{filter.label}</span>
                                                </Chips>
                                            </div>
                                        ))}
                                    </div>
                                );
                            })}
                            <div className="item">
                                <Button
                                    className="item__clear"
                                    tag="button"
                                    color="flat"
                                    onClick={onClearFilters}
                                    size="sm"
                                    weight="500"
                                    noWrap={true}
                                >
                                    <Icon name="x" size={14} color="primary" />
                                    Wyczyść filtry
                                </Button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default ProductOffersActiveFilters;
